import { createVNode as _createVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("h6", { class: "mb-5" }, "Tambah User", -1)
const _hoisted_2 = { class: "flex flex-col flex-auto" }
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { class: "mb-6" }, "Informasi Login", -1)
const _hoisted_4 = { class: "grid grid-cols-1 md:grid-cols-2 gap-8" }
const _hoisted_5 = { class: "mb-4" }
const _hoisted_6 = { class: "p-inputgroup input-icon-left-white left-radius" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "p-inputgroup-addon background-grey-lighten-4 label text-sm left-radius" }, [
  /*#__PURE__*/_createVNode("p", null, "Username")
], -1)
const _hoisted_8 = { class: "p-error" }
const _hoisted_9 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_10 = { class: "p-inputgroup input-icon-left-white left-radius" }
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "p-inputgroup-addon background-grey-lighten-4 label text-sm left-radius" }, [
  /*#__PURE__*/_createVNode("p", null, "Password")
], -1)
const _hoisted_12 = { class: "p-error" }
const _hoisted_13 = /*#__PURE__*/_createVNode("p", { class: "mb-6" }, "Informasi User", -1)
const _hoisted_14 = { class: "grid grid-cols-1 md:grid-cols-2 gap-8" }
const _hoisted_15 = { class: "mb-4" }
const _hoisted_16 = { class: "p-inputgroup input-icon-left-white left-radius" }
const _hoisted_17 = /*#__PURE__*/_createVNode("span", { class: "p-inputgroup-addon background-grey-lighten-4 label text-sm left-radius" }, [
  /*#__PURE__*/_createVNode("p", null, "Nama")
], -1)
const _hoisted_18 = { class: "p-error" }
const _hoisted_19 = { class: "mb-4" }
const _hoisted_20 = { class: "p-inputgroup input-icon-left-white left-radius" }
const _hoisted_21 = /*#__PURE__*/_createVNode("span", { class: "p-inputgroup-addon background-grey-lighten-4 label text-sm left-radius" }, [
  /*#__PURE__*/_createVNode("p", null, "Jabatan")
], -1)
const _hoisted_22 = { class: "p-error" }
const _hoisted_23 = { class: "mb-4" }
const _hoisted_24 = { class: "p-inputgroup input-icon-left-white left-radius" }
const _hoisted_25 = /*#__PURE__*/_createVNode("span", { class: "p-inputgroup-addon background-grey-lighten-4 label text-sm left-radius" }, [
  /*#__PURE__*/_createVNode("p", null, "Email")
], -1)
const _hoisted_26 = { class: "p-error" }
const _hoisted_27 = { class: "mb-4" }
const _hoisted_28 = { class: "p-inputgroup input-icon-left-white left-radius" }
const _hoisted_29 = /*#__PURE__*/_createVNode("span", { class: "p-inputgroup-addon background-grey-lighten-4 label text-sm left-radius " }, [
  /*#__PURE__*/_createVNode("p", null, "Agen")
], -1)
const _hoisted_30 = { class: "p-error" }
const _hoisted_31 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_32 = { class: "p-inputgroup input-icon-left-white left-radius" }
const _hoisted_33 = /*#__PURE__*/_createVNode("span", { class: "p-inputgroup-addon background-grey-lighten-4 label text-sm left-radius" }, [
  /*#__PURE__*/_createVNode("p", null, "Status")
], -1)
const _hoisted_34 = { class: "action-button py-5" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode("Simpan")
const _hoisted_36 = /*#__PURE__*/_createTextVNode("Kembali")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Field = _resolveComponent("Field")
  const _component_Password = _resolveComponent("Password")
  const _component_Card = _resolveComponent("Card")
  const _component_MultiselectAsync = _resolveComponent("MultiselectAsync")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Button = _resolveComponent("Button")
  const _component_Form = _resolveComponent("Form")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_Form, {
      id: "form-user",
      onSubmit: _ctx.submitData,
      "validation-schema": _ctx.schemaForm,
      "initial-values": _ctx.dataForm,
      ref: "refForm"
    }, {
      default: _withCtx(({ errors, values, setFieldValue }) => [
        _createVNode(_component_Card, { class: "user-edit" }, {
          content: _withCtx(() => [
            _hoisted_1,
            _createVNode("section", _hoisted_2, [
              _createVNode(_component_Card, { class: "card-no-shadow" }, {
                content: _withCtx(() => [
                  _hoisted_3,
                  _createVNode("div", _hoisted_4, [
                    _createVNode("div", _hoisted_5, [
                      _createVNode("div", _hoisted_6, [
                        _hoisted_7,
                        _createVNode(_component_Field, { name: "Username" }, {
                          default: _withCtx(({ field }) => [
                            _createVNode(_component_InputText, _mergeProps({ placeholder: "Username" }, field, {
                              disabled: _ctx.id ? true : false
                            }), null, 16, ["disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createVNode("small", _hoisted_8, _toDisplayString(errors.Username), 1)
                    ]),
                    (!Boolean(_ctx.id))
                      ? (_openBlock(), _createBlock("div", _hoisted_9, [
                          _createVNode("div", _hoisted_10, [
                            _hoisted_11,
                            _createVNode(_component_Field, { name: "Password" }, {
                              default: _withCtx(({ field }) => [
                                _createVNode(_component_Password, _mergeProps({
                                  class: "flex-auto",
                                  toggleMask: true,
                                  feedback: false,
                                  placeholder: "Kata Sandi Baru"
                                }, field), null, 16)
                              ]),
                              _: 1
                            })
                          ]),
                          _createVNode("small", _hoisted_12, _toDisplayString(errors.Password), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_Card, { class: "card-no-shadow mt-5" }, {
                content: _withCtx(() => [
                  _hoisted_13,
                  _createVNode("div", _hoisted_14, [
                    _createVNode("div", _hoisted_15, [
                      _createVNode("div", _hoisted_16, [
                        _hoisted_17,
                        _createVNode(_component_Field, { name: "Fullname" }, {
                          default: _withCtx(({ field }) => [
                            _createVNode(_component_InputText, _mergeProps({ placeholder: "Nama" }, field), null, 16)
                          ]),
                          _: 1
                        })
                      ]),
                      _createVNode("small", _hoisted_18, _toDisplayString(errors.Fullname), 1)
                    ]),
                    _createVNode("div", _hoisted_19, [
                      _createVNode("div", _hoisted_20, [
                        _hoisted_21,
                        _createVNode(_component_Field, { name: "GroupUser" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_MultiselectAsync, {
                              idInput: "group-user-input",
                              endpoint: "/identity/v2/msgroupusers",
                              modelValue: values.GroupUser,
                              searchFields: ['nama'],
                              filters: [['isActive', '=', 'true']],
                              placeholder: "Cari berdasarkan nama",
                              fieldLabel: "Nama",
                              style: {"border":"0.5px solid #ced4da","border-radius":"0 0.5rem 0.5rem 0px"},
                              "onUpdate:modelValue": (val) => setFieldValue('GroupUser', val)
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _createVNode("small", _hoisted_22, _toDisplayString(errors.GroupUser), 1)
                    ]),
                    _createVNode("div", _hoisted_23, [
                      _createVNode("div", _hoisted_24, [
                        _hoisted_25,
                        _createVNode(_component_Field, { name: "Email" }, {
                          default: _withCtx(({ field }) => [
                            _createVNode(_component_InputText, _mergeProps({
                              placeholder: "Email",
                              type: "email"
                            }, field), null, 16)
                          ]),
                          _: 1
                        })
                      ]),
                      _createVNode("small", _hoisted_26, _toDisplayString(errors.Email), 1)
                    ]),
                    _createVNode("div", _hoisted_27, [
                      _createVNode("div", _hoisted_28, [
                        _hoisted_29,
                        _createVNode(_component_Field, { name: "Agent" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_MultiselectAsync, {
                              idInput: "agent-input",
                              endpoint: "/backend/v2/msagens",
                              style: {"border":"0.5px solid #ced4da","border-radius":"0 0.5rem 0.5rem 0px"},
                              fieldValue: "Code",
                              searchFields: ['name'],
                              filters: [['isActive', '=', 'true']],
                              placeholder: "Cari berdasarkan nama agen",
                              modelValue: values.Agent,
                              "onUpdate:modelValue": (val) => setFieldValue('Agent', val)
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _createVNode("small", _hoisted_30, _toDisplayString(errors.Agent), 1)
                    ]),
                    (_ctx.id)
                      ? (_openBlock(), _createBlock("div", _hoisted_31, [
                          _createVNode("div", _hoisted_32, [
                            _hoisted_33,
                            _createVNode(_component_Dropdown, {
                              options: _ctx.statusOption,
                              optionLabel: "name",
                              optionValue: "id",
                              class: "flex-auto",
                              placeholder: "pilih status",
                              modelValue: values.IsActive,
                              "onUpdate:modelValue": ($event: any) => (values.IsActive = $event)
                            }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 2
              }, 1024),
              _createVNode("div", _hoisted_34, [
                _createVNode(_component_Button, {
                  class: "btn-primary text-black mr-3 px-10 py-1",
                  type: "submit"
                }, {
                  default: _withCtx(() => [
                    _hoisted_35
                  ]),
                  _: 1
                }),
                _createVNode(_component_Button, {
                  class: "btn-secondary text-black px-10 py-1",
                  type: "button",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.redirectBack()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_36
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["onSubmit", "validation-schema", "initial-values"])
  ]))
}